<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="60%" :before-close="handleClose"
		:close-on-click-modal="false">
		<el-table :data="grid_data" height="450px" border highlight-current-row v-loading="listLoading" style="width: 100%;">
			<el-table-column prop="name" label="名称" width="150">
				<template scope="scope">
					<el-input v-model="scope.row.name" auto-complete="off" size="small" maxLength="100" />
				</template>
			</el-table-column>
			<el-table-column label="操作" width="250">
				<template scope="scope">
					<el-button size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()" size="small">取 消</el-button>
			<el-button type="primary" @click="addTableRow()" size="small">新增一行</el-button>
			<el-button type="primary" @click="handleSubmit()" size="small">确 定</el-button>
		</div>
	</el-dialog>

</template>
<script>
export default {
	name: "addSave",
	props: ["showTitle", "dialogAddShow", "mid"],
	data() {
		return {
			addForm: {
				id:0,
				name: '',
			},
			roleIDsDict: [],
			userRules: {},
			delIds:[]
		};
	},
	watch: {
		dialogAddShow: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.grid_data=[]
					this.addTableRow()
					this.addTableRow()
					this.addTableRow()
				}
			},
			deep: true
		}
	},
	methods: {
		delInfo(index,row){
			this.grid_data.splice(index,1)
		},
		addTableRow() {
			let newcols={...this.addForm}
			this.grid_data.push(
				JSON.parse(JSON.stringify(newcols))
			)
		},
		handleClose() {
			this.$emit("getVisible", false);
		},
		handleSubmit() {
			let formData = this.$util.jsonToForm({ detailList: this.grid_data });
					this.$axios.post("/basic/sensitivewordsinfosave", formData).then(res => {
						if (res.data.status == 0) {
							this.$message("保存成功!");
							this.$emit("saveCallBack");
						}else {
							this.$message(res.data.msg);
						}
					});
		}
	}
};
</script>

<style lang="less" scoped></style>
